import { media } from 'responsive/media';
import styled, { css } from 'styled-components';

export const RangePickerStyled = styled.div`
  .responsive-choose-date {
    width: 276px;
    height: 40px;

    ${media.xxlDown(css`
      height: 36px;
    `)}

    ${media.xlDown(css`
      height: 32px;
    `)}

  ${media.smDown(css``)}
  }
  .ant-picker-outlined {
    width: 276px !important;
    height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #e6ebf1 !important;
    background: #fff !important;
    box-sizing: border-box !important;

    ${media.xxlDown(css`
      height: 36px;
    `)}

    ${media.xlDown(css`
      height: 32px;
    `)}

    .ant-picker .ant-picker-input > input {
      font-size: 14px !important;
    }
  }

  .custom-time-picker-dropdown {
    --arrow-x: 95.5px;
    --arrow-y: -6px;
    inset: 663px auto auto 800px !important;
    box-sizing: border-box !important;
    z-index: 1050 !important;
  }

  .ant-picker-panel-container {
    box-shadow:
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 9px 28px 8px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }

  .ant-picker-time-panel {
    border-radius: 8px;
  }

  .ant-picker-dropdown .ant-picker-panel-container {
    box-shadow:
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 9px 28px 8px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin-left: -45px !important;
  }

  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout {
    margin-left: -45px !important;
  }
`;

export const Label = styled.div`
  width: 46px;
  align-items: center;
  font-weight: 400;
  line-height: 22px;
  color: #000;
`;

export const CustomInput = styled.div`
  .icon-wrapper .calendar-icon {
    color: #00000040 !important;
    &:hover {
      color: #888 !important;
    }
  }
`;
